import development from './dev';
import stage from './stage';
import prod from './prod';

const environments = {
  stage,
  prod,
  development,
};

const environmentKey = String(
  process.env.ENVIRONMENT
) as keyof typeof environments;

export default environments[environmentKey];

export const ENV_MODE = environmentKey;
